module.exports = __webpack_public_path__ + "static/media/icon_thinktool.88358eb6.svg";